import Url from 'c-url';

const getTargetUrl = function(url){
    let query = {}, path = '',  param = '', hash = '', newUrl = '', newquery = {};
    let paramWhiteList = ['env', 'clientType', 'td_channelid', 'gachannel', 'debug', 'adscountry'];

    if (url.indexOf('?') > -1) {
        path = url.substr(0, url.indexOf('?'));
        param = url.substr(url.indexOf('?') + 1);
        
        if (param.indexOf('#') > -1) {
            hash = param.substr(param.indexOf('#') + 1);
            param = param.substr(0, param.indexOf('#'));
        }
        query = Url.parseQuery(param);
    } else {
        path = url;
    }

    for (let i = 0, len = paramWhiteList.length; i < len; i++) {
        let key = paramWhiteList[i];
        let value = Url.query(key + '');
        
        if (paramWhiteList.indexOf(key) > -1 && value) {
            newquery[key] =  value;
        }
    }

    if ($.param(newquery)) {
        newUrl = path +  '?' + $.param(newquery);
    } else {
        newUrl = path;
    }

    if (hash) {
        newUrl += '#' + hash;
    }
    
    return newUrl;
}

export default getTargetUrl;


// WEBPACK FOOTER //
// ./js/lib/util/geturl.js